import Proposal, { CompleteProposalSpec, ProposalMetaInfo } from "work/entities/proposal/proposal";
import ProposalAPIService from "work/entities/proposal/api/proposal-api-service";
import Session from "users/session/session";
import User from "users/entities/user/user";
import WorkAgreementAPIService from "work/entities/work-agreement/api/work-agreement-api-service";

export default class ProposalFactory {
  public static createProposal(
    spec: CompleteProposalSpec, 
    currentUser: User, 
    session: Readonly<Session>, 
    metaInfo?: ProposalMetaInfo
  ): Proposal {
    const workAgreementApiService = new WorkAgreementAPIService(session);
    return new Proposal(
      new ProposalAPIService(session, workAgreementApiService),
      workAgreementApiService,
      currentUser, 
      spec, 
      undefined, 
      metaInfo, 
      undefined,
      false
    );
  }

  public static updateProposal(
    oldProposal: Proposal, 
    currentUser: User, 
    spec: CompleteProposalSpec, 
    session: Readonly<Session>
  ): Proposal {
    const workAgreementApiService = new WorkAgreementAPIService(session);
    return new Proposal(
      new ProposalAPIService(session, workAgreementApiService),
      workAgreementApiService, 
      currentUser, 
      spec, 
      oldProposal, 
      oldProposal.metaInfo, 
      undefined,
      false
    );
  }
}
